import { Component, OnInit } from "@angular/core";
import { OrganizationService } from "@onsip/common/services/api/resources/organization/organization.service";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "onsip-contact",
  templateUrl: "./contact.component.html",
  standalone: false
})
export class ContactComponent implements OnInit {
  constructor(private orgService: OrganizationService) {}
  organization$ = this.orgService.organization;
  isDataObtained$ = new BehaviorSubject(false);
  contactPanel$ = new BehaviorSubject<"view" | "edit">("view");

  ngOnInit(): void {
    this.orgService.organizationRead().finally(() => this.isDataObtained$.next(true));
  }

  togglePanel(panel: "view" | "edit"): void {
    this.contactPanel$.next(panel);
  }
}
